import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as lcMutation from "@/store/levy-collections/mutation-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { LOAD_DYNAMIC_LOOKUPS } from "@/store/lookups/action-types";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";

export const actions = {
  async [action.CREATE]({ commit, dispatch }, levyCollectionId) {
    commit(mutation.CREATE_STARTED, levyCollectionId);
    try {
      let { data } = await axios.post("/api/levy-collection-sandboxes", { levyCollectionId });
      await dispatch(LOAD_DYNAMIC_LOOKUPS);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.CREATE_SUCCEEDED, data);
      commit(SHOW_NOTIFICATION, "Levy collection sandbox created.");
      return true;
    } catch (e) {
      commit(mutation.CREATE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.DELETE]({ commit, dispatch }, levyCollectionId) {
    commit(mutation.DELETE_STARTED, levyCollectionId);
    try {
      await axios.delete(`/api/levy-collection-sandboxes/${levyCollectionId}`);
      await dispatch(LOAD_DYNAMIC_LOOKUPS);
      commit(mutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcMutation.VIEW_CLEAR);
      commit(lcpMutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.DELETE_SUCCEEDED);
      commit(SHOW_NOTIFICATION, "Levy collection sandbox deleted.");
      return true;
    } catch (e) {
      commit(mutation.DELETE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.LOAD_ORIGINAL_LEVY_COLLECTION]({ commit }, levyCollectionId) {
    commit(mutation.LOAD_ORIGINAL_LEVY_COLLECTION_STARTED, levyCollectionId);
    try {
      let riskFactors, fees, levyCollection;
      [riskFactors, fees, levyCollection] = await Promise.all([
        axios.get(`/api/levy-collections/${levyCollectionId}/risk-factors`),
        axios.get(`/api/levy-collections/${levyCollectionId}/fees`),
        axios.get(`/api/levy-collections/${levyCollectionId}`)
      ]);
      commit(mutation.LOAD_ORIGINAL_LEVY_COLLECTION_SUCCEEDED, {
        riskFactors: riskFactors.data,
        fees: fees.data,
        levyCollection: levyCollection.data
      });
    } catch (e) {
      commit(mutation.LOAD_ORIGINAL_LEVY_COLLECTION_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
